import { Button, Typography } from '@navi/web-ui/lib/primitives';
import { ModalFormatTimeForLhBlocking } from './utils';
import AlertCircleIcon from '@cp/src/assets/icons/AlertCircleIcon';
import Modal from '@cp/src/components/Modal/Modal';

interface ModalWarningProps {
  handleOnClose: () => void;
  timeLeft: number;
}

const ModalWarning = ({ handleOnClose, timeLeft }: ModalWarningProps) => {
  return (
    <Modal visible={true} onClose={handleOnClose} showCloseIcon={false}>
      <div className="flex items-center gap-2 mb-4">
        <AlertCircleIcon width={24} height={24} />
        <Typography variant="h3" color="var(--navi-color-gray-c1)">
          Attention! Login to COSMOS app
        </Typography>
      </div>
      <div className="bg-red-50 p-3 rounded-lg w-80 mb-4 flex flex-col  text-left">
        <div className="flex items-center text-left">
          <Typography variant="p4" color="var(--navi-color-gray-c2)">
            In&nbsp;
          </Typography>
          <Typography variant="h3" color="var(--navi-color-red-base)">
            {ModalFormatTimeForLhBlocking(timeLeft)}
          </Typography>
          <Typography variant="p4" color="var(--navi-color-gray-c2)">
            &nbsp;you will be blocked on Longhorn!
          </Typography>
        </div>
        <Typography variant="p4" color="var(--navi-color-gray-c2)">
          To avoid this, please login to COSMOS app...
        </Typography>
      </div>
      <Button variant="primary" size="large" onClick={handleOnClose} className={'w-full'}>
        Okay, Got it
      </Button>
    </Modal>
  );
};

export default ModalWarning;
